/**
 * Production-safe logger.
 * Logs are suppressed in production builds to prevent information leakage
 * and reduce performance overhead.
 */
const isDev = process.env.NODE_ENV === 'development';

const devLog = {
  log: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { console.error(...args); },  // Always log errors
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};

export default devLog;
